<template>
  <div class="wrapper">
    <div class="img-wrapper">
      <img :src="Loading" />
    </div>
  </div>
</template>
<script>
import { Loading } from '@/images'
export default {
  data () {
    return {
      Loading
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: $color-stage1;
  .img-wrapper {
    width: 22.5px;
    height: 22.5px;
    animation: rotation 1s infinite linear;
    img {
      width: 22.5px;
      height: 22.5px;
    }
  }
}
</style>
